"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoodOrderAvailability = exports.AttributeTypes = void 0;
var AttributeTypes;
(function (AttributeTypes) {
    AttributeTypes["VE"] = "Vegan";
    AttributeTypes["V"] = "Vegetarian";
    AttributeTypes["GF"] = "Gluten Free";
})(AttributeTypes = exports.AttributeTypes || (exports.AttributeTypes = {}));
var FoodOrderAvailability;
(function (FoodOrderAvailability) {
    FoodOrderAvailability["NotAvailable"] = "NOT_AVAILABLE";
    FoodOrderAvailability["PartyOnly"] = "PARTY_ONLY";
    FoodOrderAvailability["All"] = "ALL";
})(FoodOrderAvailability = exports.FoodOrderAvailability || (exports.FoodOrderAvailability = {}));
//# sourceMappingURL=StoreTypes.js.map